import { jsx as _jsx } from "react/jsx-runtime";
import parse, { domToReact } from 'html-react-parser';
export default function LosseContent({ className = '', replace, children = '', ...rest }) {
    return (_jsx("div", { className: `parsecontent ${className}`, ...rest, children: typeof children === 'string' ? findAndReplace(children || '', typeof replace !== 'undefined' ? replace : () => null) : children }));
}
export const losseContentToReact = domToReact;
export const losseContentParse = (content = '', settings) => {
    if (content && typeof content === 'string') {
        return parse(content, settings);
    }
    return null;
};
const findAndReplace = (content, replace) => parse(content, {
    replace
});
